<template>
  <div class="grid max-h-42 grid-cols-3 gap-1.5 overflow-y-auto v-tracklify-scroll">
    <div
      v-for="ttbu in ttbus"
      :key="ttbu.id"
      class="flex flex-col items-center justify-center gap-1 overflow-hidden rounded-chip
             px-1 py-1.5"
      :class="ttbu.ttbuObj.trackingOnline ? 'bg-accent text-on-accent' : 'bg-input text-text'"
    >
      <UserAvatar noBorder class="size-6.5! [&_.content]:text-label" :user="getUser(ttbu.userId)" />

      <IntervalHolder
        class="text-body leading-none font-bold"
        :isActive="ttbu.ttbuObj.trackingOnline"
        :ttbu="ttbu.ttbuObj"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import IntervalHolder from '@/components/elements/IntervalHolder';

defineProps({
  ttbus: {
    type: Array,
    required: true,
  },
});

const store = useStore();
const getUser = computed(() => store.getters['user/getUser']);
</script>
